import React from "react";
import styled, { css } from "styled-components";

export type BadgeType = "success" | "danger" | "info" | "discarded";

type BadgeProps = {
    className?: string;
    type: BadgeType;
    children: React.ReactNode;
};

const Badge = ({ className, type, children }: BadgeProps): JSX.Element => {
    return (
        <Container className={className} type={type} tabIndex={0}>
            {children}
        </Container>
    );
};

const Container = styled.div<{ type: BadgeType }>`
    display: inline-block;
    padding: 2px 4px;
    border-radius: 0;
    font-size: 12px;

    ${(props) =>
        props.type === "success" &&
        css`
            background-color: #00847F;
            color: #fff;
            // background-color: var(--bs-success-bg);
            // color: var(--bs-success);
        `}

    ${(props) =>
        props.type === "danger" &&
        css`
            background-color: var(--bs-danger-bg);
            color: #fff;
            // color: var(--bs-danger);
        `}

    ${(props) =>
        props.type === "info" &&
        css`
            background-color: #33618F;
            color: #fff;
            // background-color: var(--bs-info-bg);
            // color: var(--bs-label-grey);
        `}

    ${(props) =>
        props.type === "discarded" &&
        css`
            background-color: #D7D8D6;
            color: #333333;
            // background-color: var(--bs-border-grey);
            // color: var(--bs-dark);
        `}
    
    & + & {
        margin-left: 1rem;
    }
`;

export default Badge;
